const Numeric = require("app/components/fields/Numeric");
const assign = require("object-assign");

class EAN extends Numeric {

	get elementProps() {
		return assign({}, super.elementProps, {
			maxLength: 13
		});
	}

}

module.exports = EAN;